import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import { Toaster } from './components/ui/sonner';
import ErrorBoundary from './components/ErrorBoundary';
import { ApiProvider } from './contexts/ApiContext';
import { MusicProvider } from './contexts/MusicContext';

function App() {
  return (
    <ErrorBoundary>
      <ApiProvider>
        <MusicProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<HomePage />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" />
          </div>
        </MusicProvider>
      </ApiProvider>
    </ErrorBoundary>
  );
}

export default App;